import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Card, ImageAssetFactory } from '../../domain/card';
import { ImageAsset, ImageAssetType } from '../../domain/types';
import { I18nKeys } from '@jump-tech-frontend/app-config';
import { QuestionsComponent } from '../../core/questions.component';

import { ImageAssetComponent } from '../../core/image-asset.component';

@Component({
  selector: 'crds-address-form',
  templateUrl: './address-form.component.html',
  imports: [ImageAssetComponent, ReactiveFormsModule, QuestionsComponent]
})
export class AddressFormComponent implements OnChanges {
  @Input() form: UntypedFormGroup;
  @Input() card: Card<null>;
  @Input() addresses: any[];
  @Input() i18ns: I18nKeys;
  @Input() deviceContext?: string = 'desktop';
  images: ImageAsset[];
  imageAssetType = ImageAssetType;

  constructor(private imageAssetFactory: ImageAssetFactory) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.card || !Object.prototype.hasOwnProperty.call(changes, 'card')) {
      return;
    }

    this.images = this.imageAssetFactory.create(this.card.image, this.form);
  }
}
